export default function(prefix='id') {
    let id = Math.floor(Math.random() * (9999999 - 1)) + 1;
    return `${prefix}${id}`;
}



// WEBPACK FOOTER //
// ./src/utils/newid.js